import { createContext, useContext } from "react";

const TableContext = createContext(false);

export const TableProvider = TableContext.Provider;
export const useIsInTable = () => useContext(TableContext);
